import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import { Modal, Button, Icon } from 'components/UI';
import { showApiError } from 'utils';
import { generate2fa } from 'services';
import { container, title, qrWrapper, secretCode, copiedText, instructions, stepsList } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var TwoFactorModal = function TwoFactorModal(_ref) {
  var modalRef = _ref.modalRef,
      userId = _ref.userId;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      copied = _useState4[0],
      setCopied = _useState4[1];

  var handleOpen = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$generate2fa, _yield$generate2fa2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return generate2fa(userId);

            case 2:
              _yield$generate2fa = _context.sent;
              _yield$generate2fa2 = _slicedToArray(_yield$generate2fa, 2);
              res = _yield$generate2fa2[0];
              err = _yield$generate2fa2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setData(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOpen() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose() {
    setData(null);
    setCopied(false);
  };

  var handleCopy = function handleCopy() {
    navigator.clipboard.writeText(data.secret);
    setCopied(true);
    setTimeout(function () {
      return setCopied(false);
    }, 2000);
  };

  return ___EmotionJSX(Modal, {
    ref: modalRef,
    onOpen: handleOpen,
    onClose: handleClose
  }, data && ___EmotionJSX("div", {
    css: container
  }, ___EmotionJSX("h4", {
    css: title
  }, "\u0414\u0432\u0443\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u043A\u0430\u0446\u0438\u044F"), ___EmotionJSX("p", {
    css: instructions
  }, "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435 QR \u043A\u043E\u0434\u0430 \u0441 Google Authenticator \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u043A\u0430\u0446\u0438\u044F:"), ___EmotionJSX("ol", {
    css: stepsList
  }, ___EmotionJSX("li", null, "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435 Google Authenticator \u043D\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u0441\u0438"), ___EmotionJSX("li", null, "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 \"+\" \u0437\u0430 \u0434\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u043D\u043E\u0432 \u0430\u043A\u0430\u0443\u043D\u0442"), ___EmotionJSX("li", null, "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \"\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 QR \u043A\u043E\u0434\""), ___EmotionJSX("li", null, "\u041D\u0430\u0441\u043E\u0447\u0435\u0442\u0435 \u043A\u0430\u043C\u0435\u0440\u0430\u0442\u0430 \u043A\u044A\u043C QR \u043A\u043E\u0434\u0430 \u043F\u043E-\u0434\u043E\u043B\u0443")), ___EmotionJSX("div", {
    css: qrWrapper
  }, ___EmotionJSX(QRCodeSVG, {
    value: data.qr_code_url,
    size: 200
  })), ___EmotionJSX("p", {
    css: instructions
  }, "\u0418\u043B\u0438 \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0440\u044A\u0447\u043D\u043E \u0442\u043E\u0437\u0438 \u043A\u043E\u0434 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E:"), ___EmotionJSX("div", {
    css: secretCode
  }, data.secret, ___EmotionJSX(Icon, {
    iconName: "las la-copy",
    size: 18,
    onClick: handleCopy
  })), copied && ___EmotionJSX("span", {
    css: copiedText
  }, "\u041A\u043E\u0434\u044A\u0442 \u0435 \u043A\u043E\u043F\u0438\u0440\u0430\u043D!"), ___EmotionJSX(Button, {
    small: true,
    onClick: function onClick() {
      var _modalRef$current;

      return (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.close();
    }
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438")));
};

TwoFactorModal.propTypes = {
  modalRef: PropTypes.object,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default TwoFactorModal;